import React from "react";
import { ITableChange } from "./LineItemsStreams";
import { IErrorTypes, accountTypeValidation, ErrorTypes } from "./LineItemsValidationUtilities";
import { sanitizeInputToBlankOrInput } from "./LineItemsUtilities";
import { default as numeral } from "numeral";

/* 
Line Items Rules
1. Document Amount cell must be stripped of Numeric formatting (e.g., (100,000) => -100000
2. If Account Type is Vendor OR Customer then Cost Center, Internal Order, and Profit Center must be blank string
3. If Account Type is Vendor OR Customer then Trading Partner must be non blank
 */
//
export function validateLineItems(
  setErrors: React.Dispatch<React.SetStateAction<Record<string, unknown> | IErrorTypes>>,
  lineItems: string[][]
): void {
  // Start with a Blank Errors object
  // Operation adds errors
  // setErrors at the End
  // TODO: Move this iteration to a worker
  let previousAccountType: string | null = null;
  let previousAccountNumber: string | null = null;
  const errors: IErrorTypes | Record<string, unknown> = lineItems.reduce((theErrors, row) => {
    const accountType = sanitizeInputToBlankOrInput(row[0]);
    if (accountType !== "" && (accountType.startsWith("Vendor") || accountType.startsWith("Customer"))) {
      if (!(ErrorTypes.VendorOrCustomer in theErrors)) {
        if (accountTypeValidation(row)) {
          theErrors[ErrorTypes.VendorOrCustomer] =
            "Account Type Vendor/Customer must not have Cost Center, Internal Order, and Profit Center.";
        }
      }
      if (previousAccountType === null) {
        previousAccountType = accountType;
      } else {
        if (accountType !== previousAccountType && !(ErrorTypes.VendorAndCustomerInEntry in theErrors)) {
          theErrors[ErrorTypes.VendorAndCustomerInEntry] =
            "A single Entry can't combine Account Types Vendor and Customer.";
        }
      }
      const accountNumber = sanitizeInputToBlankOrInput(row[1]);
      if (previousAccountNumber === null) {
        previousAccountNumber = accountNumber;
      } else {
        if (
          `${accountType},${accountNumber}` !== `${previousAccountType},${previousAccountNumber}` &&
          !(ErrorTypes.MultipleVendorsOrCustomersInEntry in theErrors)
        ) {
          theErrors[ErrorTypes.MultipleVendorsOrCustomersInEntry] =
            "A single Entry using Account Types Vendor and Customer must use the same combination of Account Type and Account Number.";
        }
      }
    }
    return theErrors;
  }, {} as IErrorTypes);
  if (lineItems.length < 2) {
    (errors as IErrorTypes)[ErrorTypes.AtLeastTwoLineItemsNeeded] = "Please add at least 2 line items to Entry.";
  }
  setErrors(errors);
}

export function validateAndFormatAllLineItems(
  setErrors: React.Dispatch<React.SetStateAction<Record<string, unknown> | IErrorTypes>>,
  values: string[][]
): string[][] {
  const newValues = values.map((row) => {
    if (10 in row) {
      row[10] = numeral(row[10]).format("(0,0.00)");
    }
    return row;
  });
  validateLineItems(setErrors, newValues);
  return newValues;
}

export function formatCellInPlaceAndValidateAllLineItems(
  setErrors: React.Dispatch<React.SetStateAction<Record<string, unknown> | IErrorTypes>>,
  values: string[][],
  { row, column, currentVal }: Pick<ITableChange, "row" | "column" | "currentVal">
): void {
  if (column === 10) {
    values[row][column] = numeral(currentVal || "").format("(0,0.00)");
  } else {
    values[row][column] = currentVal ? currentVal : "";
  }
  validateLineItems(setErrors, values);
}
